/**
 * Created by Desarrollo KJ on 20/3/2017.
 */
import { Component, Input, OnInit } from '@angular/core';
import {FloatButtonCartService} from './../floatButtonCart/floatButtonCart.service';

@Component({
  selector: 'product-mini', // <my-app></my-app>
  template: require('./productMini.html')
})
export class ProductMini implements OnInit {

  @Input() producto:any;

  public cantidad: number = 1;
  public typeUser: number = 1;

  public productoDefault:{
    idProducto:null,
    productoNombre:"",
    productoPermalink:"",
    precioNormal:0,
    precioVip:0,
    precioEventual:0,
    idCategoria:null,
    paisNombre:"",
    moneda:"",
    monedaCodigo:"",
    monedaSimbolo:"",
    categoriaNombre:"",
    categoriaRama:""
  };

  constructor(private _floatService:FloatButtonCartService) {
    this.productoDefault = this.producto;

    if(localStorage.getItem('login')){
      let user = JSON.parse(localStorage.getItem('login'));
      if(user.tipoUsuario == 'cliente'){
        this.typeUser = user.tipoCliente;
      }
    }
  }

  public validationNumber(): void {
    if(this.cantidad <= 0){
      this.cantidad = 1;
    }
    if((this.cantidad%1) > 0){
      this.cantidad = this.cantidad - (this.cantidad%1);
    }
  }

  public add(){
    this.cantidad++;
  }

  public sub(){
    if(this.cantidad > 1){
      this.cantidad--;
    }
  }

  public addToCart(){
    this._floatService.addToCart(this.productoDefault.idProducto, this.cantidad);
  }

  ngOnInit() {
    this.productoDefault = this.producto;
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/components/productMini/productMini.component.ts